import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { registerServiceWorkerUpdates } from './serviceWorkerUpdates';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Keyboard } from '@capacitor/keyboard';
import { armSplashFailsafe } from './utils/splash';

// Configure native platform features
if (Capacitor.isNativePlatform()) {
  // The web content sits BELOW the status bar rather than under it, so the
  // strip is painted natively and the CSS never has to pay for the top inset.
  // Android reaches the same place a different way — this call is inert there
  // on 15+, so MainActivity pads the WebView's parent instead. See the --safe-*
  // block in index.css, and capacitor.config.ts.
  StatusBar.setOverlaysWebView({ overlay: false });
  // Style.Dark means dark BACKGROUND, i.e. light text — which is what a navy
  // strip needs. Named the confusing way round by the plugin, not by us.
  StatusBar.setStyle({ style: Style.Dark });
  // Read from --brand-navy rather than repeated as a literal: this was
  // '#0f172a' against a token of '#0B131E', which is a visible seam directly
  // above the header on Android. (iOS ignores this call — the plugin's
  // setBackgroundColor is Android-only — and takes its colour from
  // `ios.backgroundColor` in capacitor.config.ts instead.)
  const navy = getComputedStyle(document.documentElement)
    .getPropertyValue('--brand-navy').trim();
  if (navy) StatusBar.setBackgroundColor({ color: navy });

  // The splash waits for SubscriptionGate (utils/splash.js); this is the cap.
  armSplashFailsafe();

  Keyboard.setAccessoryBarVisible({ isVisible: true });
  Keyboard.setScroll({ isDisabled: false });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Controlled service-worker update flow (extracted to its own module so the
// UpdateBanner UI can import applyUpdate without importing this render entry).
registerServiceWorkerUpdates();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
